export const Spinner = () => {
  return (
    <div className="w-20">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        fill="none"
        stroke="currentcolor"
        strokeWidth={4}
        preserveAspectRatio="xMidYMid meet"
      >
        <circle
          cx="50%"
          cy="50%"
          r="45"
          className="h-1 w-1 origin-center animate-spinner-stroke-rotation fill-transparent stroke-[10%]"
          style={{
            transition: "stroke 225ms linear 0s",
            strokeDasharray: "282.743px",
            color: "#353584",
          }}
        />
      </svg>
    </div>
  );
};
